import React from 'react'
import coffee1 from "./images/coffee1.jpg"
import coffee2 from "./images/coffee2.jpg"
import coffee3 from "./images/coffee3.jpg"
import coffee4 from "./images/coffee4.jpg"
import coffee5 from "./images/coffee5.jpg"
import coffee6 from "./images/coffee6.jpg"
import coffee7 from "./images/coffee7.jpg"
import coffee8 from "./images/coffee8.jpg"
import coffee9 from "./images/coffee9.jpg"



export default function Services() {
  return (
      <>
      <div className="container">
         <div className=" flex flex-3 imagebox hidden" onClick={showPrice} >
          <img className='coffeeimg' id="p13" src={coffee1} alt="coffee1" width="250" height="250" /><br/>
          <p className="coffeeinfo">Lorem ipsum dolor sit amet consectetur,
           adipisicing elit. Ut, debitis praesentium laboriosam quia cumque a</p>
           <br/>
           <button className="btn btncust">Special price </button>
         </div>
         
         <div className="flex flex-3  imagebox hidden" onClick={showPrice}>
          <img className='coffeeimg' id="p15" src={coffee2} alt="coffee2" width="250" height="250"/><br/>
          <p className="coffeeinfo">Lorem ipsum dolor sit amet consectetur,
           adipisicing elit. Ut, debitis praesentium laboriosam quia cumque a</p>
           <br/>
           <button className="btn btncust">Special price </button>
         </div>
           
         <div className="flex flex-3  imagebox hidden" onClick={showPrice}>
          <img className='coffeeimg' id="p9" src={coffee3} alt="coffee3" width="250" height="250"/><br/>
          <p className="coffeeinfo">Lorem ipsum dolor sit amet consectetur,
           adipisicing elit. Ut, debitis praesentium laboriosam quia cumque a</p>
           <br/>
           <button className="btn btncust">Special price </button>
         </div>

         <div   className=" flex flex-3 imagebox hidden" onClick={showPrice}>
          <img className='coffeeimg' id="p18" src={coffee4} alt="coffee4" width="250" height="250"/><br/>
          <p className="coffeeinfo">Lorem ipsum dolor sit amet consectetur,
           adipisicing elit. Ut, debitis praesentium laboriosam quia cumque a</p>
           <br/>
           <button className="btn btncust">Special price </button>
         </div>
         
         <div className="flex flex-3  imagebox hidden" onClick={showPrice}>
          <img className='coffeeimg' id="p11" src={coffee5} alt="coffee5" width="250" height="250"/><br/>
          <p className="coffeeinfo">Lorem ipsum dolor sit amet consectetur,
           adipisicing elit. Ut, debitis praesentium laboriosam quia cumque a</p>
           <br/>
            <button className="btn btncust">Special price </button>
         </div>
           
         <div className="flex flex-3  imagebox hidden" onClick={showPrice}>
          <img className='coffeeimg' id="p22" src={coffee6} alt="coffee6" width="250" height="250"/><br/>
          <p className="coffeeinfo">Lorem ipsum dolor sit amet consectetur,
           adipisicing elit. Ut, debitis praesentium laboriosam quia cumque a</p>
           <br/>
           <button className="btn btncust">Special price </button>
         </div>

         <div className=" flex flex-3 imagebox hidden" onClick={showPrice}>
          <img className='coffeeimg' id="p19" src={coffee7} alt="coffee7" width="250" height="250"/><br/>
          <p className="coffeeinfo">Lorem ipsum dolor sit amet consectetur,
           adipisicing elit. Ut, debitis praesentium laboriosam quia cumque a</p>
           <br/>
           <button className="btn btncust">Special price </button>
         </div>
         
         <div className="flex flex-3  imagebox hidden" onClick={showPrice}>
          <img className='coffeeimg' id="p17.95" src={coffee8} alt="coffee8" width="250" height="250"/><br/>
          <p className="coffeeinfo">Lorem ipsum dolor sit amet consectetur,
           adipisicing elit. Ut, debitis praesentium laboriosam quia cumque a</p>
           <br/>
            <button className="btn btncust">Special price </button>
         </div>
           
         <div className="flex flex-3  imagebox hidden" onClick={showPrice}>
          <img className='coffeeimg' id="p7.85" src={coffee9} alt="coffee9" width="250" height="250"/><br/>
          <p className="coffeeinfo">Lorem ipsum dolor sit amet consectetur,
           adipisicing elit. Ut, debitis praesentium laboriosam quia cumque a</p>
           <br/>
           <button className="btn btncust">Special price </button>
         </div>

         
      </div>

     
     


      </>
  
  )
}




function showPrice(e){

let popUp = document.createElement('div');
var randName = Math.random().toString(16).substr(9)

popUp.innerHTML=`
<br/>
  <h4>Coffee-${randName}</h4><br/>
  <center><img src=${e.currentTarget.firstChild.src} width="100" height="100" alt='coffeeImage'/></center>
  <br/>
   <p>It only costs <span class="price"> ${e.currentTarget.firstChild.id.replace("p","")} $</span></p>


`;

var rect = e.currentTarget.firstChild.getBoundingClientRect()


popUp.setAttribute("class","popup")
popUp.style.position="fixed";
popUp.style.top = rect.y+8+"px" 
popUp.style.left = rect.x+8+"px"


popUp.style.width="230px"
popUp.style.height="235px"
popUp.style.background="rgba(1,1,1,0.8)"
popUp.style.color="white";
popUp.style.textAlign="center"
popUp.style.borderRadius="50%"
document.body.appendChild(popUp)

setTimeout(function(){
  document.body.removeChild(popUp)
},3000)

}


function ScrollEffect(){
  var observer = new IntersectionObserver(entries =>{
      for( let entry of entries){
          if(entry.isIntersecting){
             entry.target.classList.add("show")
          }else{
            entry.target.classList.remove("show")
          }

      }
  })

  var Elements = document.querySelectorAll(".hidden")
  for(let el of Elements){
    console.log(el)
    observer.observe(el)
  }

}

setInterval(ScrollEffect,33)

